import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Internal\RecentlySearchedPropertiesController::store
* @see app/Http/Controllers/Api/Internal/RecentlySearchedPropertiesController.php:22
* @route '/internal-api/properties/recent'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/internal-api/properties/recent',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Internal\RecentlySearchedPropertiesController::store
* @see app/Http/Controllers/Api/Internal/RecentlySearchedPropertiesController.php:22
* @route '/internal-api/properties/recent'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\RecentlySearchedPropertiesController::store
* @see app/Http/Controllers/Api/Internal/RecentlySearchedPropertiesController.php:22
* @route '/internal-api/properties/recent'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Internal\RecentlySearchedPropertiesController::index
* @see app/Http/Controllers/Api/Internal/RecentlySearchedPropertiesController.php:17
* @route '/internal-api/properties/recent'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/internal-api/properties/recent',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Internal\RecentlySearchedPropertiesController::index
* @see app/Http/Controllers/Api/Internal/RecentlySearchedPropertiesController.php:17
* @route '/internal-api/properties/recent'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\RecentlySearchedPropertiesController::index
* @see app/Http/Controllers/Api/Internal/RecentlySearchedPropertiesController.php:17
* @route '/internal-api/properties/recent'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Internal\RecentlySearchedPropertiesController::index
* @see app/Http/Controllers/Api/Internal/RecentlySearchedPropertiesController.php:17
* @route '/internal-api/properties/recent'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\Internal\RecentlySearchedPropertiesController::destroy
* @see app/Http/Controllers/Api/Internal/RecentlySearchedPropertiesController.php:27
* @route '/internal-api/properties/recent/{barcode}'
*/
export const destroy = (args: { barcode: string | number } | [barcode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/internal-api/properties/recent/{barcode}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Api\Internal\RecentlySearchedPropertiesController::destroy
* @see app/Http/Controllers/Api/Internal/RecentlySearchedPropertiesController.php:27
* @route '/internal-api/properties/recent/{barcode}'
*/
destroy.url = (args: { barcode: string | number } | [barcode: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { barcode: args }
    }

    if (Array.isArray(args)) {
        args = {
            barcode: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        barcode: args.barcode,
    }

    return destroy.definition.url
            .replace('{barcode}', parsedArgs.barcode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\RecentlySearchedPropertiesController::destroy
* @see app/Http/Controllers/Api/Internal/RecentlySearchedPropertiesController.php:27
* @route '/internal-api/properties/recent/{barcode}'
*/
destroy.delete = (args: { barcode: string | number } | [barcode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const recentlySearchedProperties = {
    store: Object.assign(store, store),
    index: Object.assign(index, index),
    destroy: Object.assign(destroy, destroy),
}

export default recentlySearchedProperties